
define('text!templates/components/reseller_product_compact/reseller_products.html',[],function () { return '<div class="list-container">\n\n</div>';});

